export function createTenantConfigurationClient(transport) {
    return {
        /**
         * Get a tenant configuration entry
         *
         * Requires scope: tenant-configuration:read
         */
        getConfiguration(namespace, key, options) {
            return transport.request({
                method: "GET",
                path: `/v1/configuration/${encodeURIComponent(namespace)}/${encodeURIComponent(key)}`,
                options,
            });
        },
        /**
         * Create or replace with optimistic concurrency
         *
         * Requires scope: tenant-configuration:write
         */
        putConfiguration(namespace, key, body, options) {
            return transport.request({
                method: "PUT",
                path: `/v1/configuration/${encodeURIComponent(namespace)}/${encodeURIComponent(key)}`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
        /**
         * List every configuration entry in one namespace
         *
         * Requires scope: tenant-configuration:read
         */
        listConfigurationNamespace(namespace, options) {
            return transport.request({
                method: "GET",
                path: `/v1/configuration/${encodeURIComponent(namespace)}`,
                options,
            });
        },
        /**
         * List this tenant's configuration entries across every namespace
         *
         * Requires scope: tenant-configuration:read
         */
        listTenantConfiguration(namespace, limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/configuration",
                query: { namespace: namespace, limit: limit, after: after },
                options,
            });
        },
    };
}
//# sourceMappingURL=tenant-configuration.js.map